import { render, staticRenderFns } from "./CardPillNav.vue?vue&type=template&id=74d6a2bf"
import script from "./CardPillNav.vue?vue&type=script&lang=js"
export * from "./CardPillNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports